import {defineStore} from "pinia";
import {personalQuestions, corporateQuestions} from "../js/ClientDetailsQuestionSets";

export const ClientStore = defineStore('client', {
    state: () => ({
        type: null,
        questionSets: {
            personal: personalQuestions,
            corporate: corporateQuestions,
        },
        questions: [],
    }),
    actions: {
        setQuestionSet(type) {
            this.type = type;
            this.questions = this.questionSets[this.type];
        },
    }
});